export default {
	home: {
		name: "首页"
	},
	page_out_trade_no: "商户单号",
	_start_recording: "开启录屏",
	_stop_recording: "结束录屏",
	_switch_obj: "切换OBJ",
	_switch_gaussian: "切换高斯",
	_switch_glb: "切换glb",
	_model_has_no_obj: "该模型暂无OBJ模型",
	_model_has_no_gaussian: "该模型无高斯模型",
	_model_does_not_exist: "模型文件不存在",
	"_no_photos!": "无照片",
	_image_loading_failed: "图片加载失败",
	_no_gaussian_model_available: "暂无高斯模型",
	_no_normal_map_available: "暂无模型法线图",
	"_model_loading_failed,_please_try_again_later": "模型加载失败",
	"_obj_model_does_not_exist,_automatically_switched_to_gaussian_preview":
		"OBJ模型不存在，已自动切换到高斯预览",
	_original_uploaded_photo: "原始上传照片",
	_effect_image: "效果图",
	submit_modeling_model_file_not_ready: "模型文件还未准备好，请稍后重试或联系客服。",
	finance_package_order_reverse: "套餐一口价红冲",
	finance_shop_red_reversal: "门店红冲",
	finance_dealer_red_reversal: "经销商红冲"
};
